import React from "react";
import { playFaqVideo, resolveFaqVideo } from "./faqMediaUtils";

function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(String(value || ""));
}

export default function FaqAnswerContent({ faq, onPlayVideo }) {
  const resolved = resolveFaqVideo(faq);
  const { hasVideo, displayAnswer } = resolved;
  // Prefer HTML render whenever markup is present so editor changes show as-is.
  const htmlAnswer = looksLikeHtml(displayAnswer || faq?.answer);

  const handlePlay = () => {
    playFaqVideo(
      { ...resolved, title: faq.question },
      {
        onGuiddePlay: (payload) => {
          if (typeof onPlayVideo === "function") onPlayVideo(payload);
        },
      },
    );
  };

  return (
    <>
      {htmlAnswer ? (
        <div
          className="faq-answer-html ql-editor"
          dangerouslySetInnerHTML={{ __html: displayAnswer || "" }}
        />
      ) : (
        <p>{displayAnswer}</p>
      )}
      {hasVideo ? (
        <div className="faq-item-actions">
          <button
            type="button"
            className="faq-video-button"
            onClick={handlePlay}
          >
            <i className="fas fa-play-circle" aria-hidden="true" />
            Watch guide video
          </button>
        </div>
      ) : null}
      {faq.hasGuide ? (
        <div className="faq-item-actions">
          <button type="button" className="faq-link-button">
            View Guide <i className="fas fa-external-link-alt" />
          </button>
        </div>
      ) : null}
    </>
  );
}
